.root {
  display: block;
}

.title {
  font-family: var(--font-heading);
  font-size: var(--type-project);
  font-weight: 600;
  text-transform: none;
  letter-spacing: normal;
  line-height: 1.15;
  text-wrap: balance;
  color: var(--color-text);
  margin-bottom: clamp(var(--space-16), 2vw, var(--space-24));
}

.list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.exercise {
  display: grid;
  gap: var(--space-14);
  padding: clamp(var(--space-20), 2.2vw, var(--space-32)) 0;
  border-top: 1px solid var(--color-border);

  &:last-child {
    border-bottom: 1px solid var(--color-border);
  }
}

.head {
  display: grid;
  gap: var(--space-4);
}

.exerciseTitle {
  font-family: var(--font-heading);
  font-size: var(--type-catalog);
  font-weight: 600;
  text-transform: none;
  letter-spacing: normal;
  line-height: 1.25;
  /* pretty, а не balance: строка заполняется до конца, только без одинокого слова в последней */
  text-wrap: pretty;
  overflow-wrap: anywhere;
  color: var(--color-text);
}

.videoMark {
  font-size: var(--type-caption);
  color: var(--color-text-muted);
}

.part {
  display: grid;
  gap: var(--space-6);
  max-width: 68ch;
}

.partLabel {
  font-size: var(--type-caption);
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--color-text-muted);
}

.text {
  font-size: 1rem;
  line-height: 1.6;
  color: var(--color-text);
}

.steps {
  font-size: 1rem;
  line-height: 1.6;
  color: var(--color-text);

  display: grid;
  gap: var(--space-6);
  padding-left: var(--space-20);

  li::marker {
    font-weight: 700;
    color: var(--color-text-muted);
  }
}

.tips {
  font-size: 1rem;
  line-height: 1.6;
  color: var(--color-text);

  display: grid;
  gap: var(--space-6);
  padding-left: var(--space-20);
  color: var(--color-text-muted);
}

.note {
  margin-top: var(--space-16);
  max-width: 68ch;
  font-size: var(--type-caption);
  line-height: 1.6;
  color: var(--color-text-muted);
}
